import { useQuery } from '@tanstack/react-query';
import { getAllLoginImages } from 'api/services';
import { useEffect, useMemo, useState } from 'react';

const useLoginLayoutImagesQuery = () => {
    const [imageIndex, setImageIndex] = useState<number>(0);

    const loginImagesQuery = useQuery(['loginImages'], () => getAllLoginImages(window.location.host), {
        retry: 0,
    });

    useEffect(() => {
        const loginImages = loginImagesQuery.data;

        if (!loginImages || loginImages.length === 0) return;

        const intervalId = setInterval(() => {
            setImageIndex((prev) => (prev + 1 === loginImages.length ? 0 : prev + 1));
        }, 10000);

        return () => clearInterval(intervalId);
    }, [loginImagesQuery.data]);

    useEffect(() => {
        const loginImages = loginImagesQuery.data;

        if (!loginImages || loginImages.length === 0) return;

        // Preload Images
        loginImages.forEach((url) => {
            const image = new Image();
            image.src = url;
        });
    }, [loginImagesQuery.data]);

    const hasImages = useMemo(() => {
        return loginImagesQuery.data && loginImagesQuery.data.length > 0;
    }, [loginImagesQuery.data]);

    return {
        isLoading: loginImagesQuery.isLoading,
        hasImages: hasImages,
        image: hasImages ? loginImagesQuery.data[imageIndex] : null,
    };
};

export default useLoginLayoutImagesQuery;
